// src/layouts/SimpleLayout.js
import React from "react";

const SimpleLayout = ({ children }) => {
  return <>{children}</>;
};

export default SimpleLayout;
